import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import MarketDetail from "./pages/MarketDetail";
import Saved from "./pages/Saved";
import Buyers from "./pages/Buyers";
import Sequences from "./pages/Sequences";
import Admin from "./pages/Admin";
import Alerts from "./pages/Alerts";
import Pricing from "./pages/Pricing";
import Billing from "./pages/Billing";
import UpgradeModal from "./components/UpgradeModal";
import "./App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-[--ink-muted]">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) {
    const params = new URLSearchParams(window.location.search);
    const next = params.get("next") || "/dashboard";
    return <Navigate to={next} replace />;
  }
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors closeButton />
          <UpgradeModal />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route
              path="/login"
              element={
                <PublicOnly>
                  <Login />
                </PublicOnly>
              }
            />
            <Route
              path="/register"
              element={
                <PublicOnly>
                  <Register />
                </PublicOnly>
              }
            />
            <Route
              path="/dashboard"
              element={
                <Protected>
                  <Dashboard />
                </Protected>
              }
            />
            <Route
              path="/market"
              element={
                <Protected>
                  <MarketDetail />
                </Protected>
              }
            />
            <Route
              path="/saved"
              element={
                <Protected>
                  <Saved />
                </Protected>
              }
            />
            <Route
              path="/buyers"
              element={
                <Protected>
                  <Buyers />
                </Protected>
              }
            />
            <Route
              path="/sequences"
              element={
                <Protected>
                  <Sequences />
                </Protected>
              }
            />
            <Route
              path="/admin"
              element={
                <Protected>
                  <Admin />
                </Protected>
              }
            />
            <Route
              path="/alerts"
              element={
                <Protected>
                  <Alerts />
                </Protected>
              }
            />
            <Route path="/pricing" element={<Pricing />} />
            <Route
              path="/billing"
              element={
                <Protected>
                  <Billing />
                </Protected>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
